import { Box, LinearProgress } from '@mui/material';

export default function LoaderComponent() {
  return (
    <Box sx={{ p: 5, width: '100%' }}>
      <LinearProgress />
    </Box>
  );
}
